/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    GuidIdCodeAndLabel,
    GuidIdCodeAndLabelFromJSON,
    GuidIdCodeAndLabelFromJSONTyped,
    GuidIdCodeAndLabelToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
} from './';

/**
 * 
 * @export
 * @interface AncillaryDistributionFormData
 */
export interface AncillaryDistributionFormData {
    /**
     * 
     * @type {string}
     * @memberof AncillaryDistributionFormData
     */
    id?: string | null;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionFormData
     */
    supplier?: GuidIdAndLabel;
    /**
     * 
     * @type {GuidIdCodeAndLabel}
     * @memberof AncillaryDistributionFormData
     */
    carrier?: GuidIdCodeAndLabel;
    /**
     * 
     * @type {GuidIdAndLabel}
     * @memberof AncillaryDistributionFormData
     */
    ancillary?: GuidIdAndLabel;
    /**
     * 
     * @type {Int32IdAndLabel}
     * @memberof AncillaryDistributionFormData
     */
    ancillaryCategory?: Int32IdAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof AncillaryDistributionFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {number}
     * @memberof AncillaryDistributionFormData
     */
    relevance?: number;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof AncillaryDistributionFormData
     */
    salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof AncillaryDistributionFormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof AncillaryDistributionFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof AncillaryDistributionFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {object}
     * @memberof AncillaryDistributionFormData
     */
    effectiveFrom?: object | null;
    /**
     * 
     * @type {object}
     * @memberof AncillaryDistributionFormData
     */
    effectiveTo?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryDistributionFormData
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AncillaryDistributionFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AncillaryDistributionFormData
     */
    additionalInformation?: string | null;
}

export function AncillaryDistributionFormDataFromJSON(json: any): AncillaryDistributionFormData {
    return AncillaryDistributionFormDataFromJSONTyped(json, false);
}

export function AncillaryDistributionFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): AncillaryDistributionFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'supplier': !exists(json, 'supplier') ? undefined : GuidIdAndLabelFromJSON(json['supplier']),
        'carrier': !exists(json, 'carrier') ? undefined : GuidIdCodeAndLabelFromJSON(json['carrier']),
        'ancillary': !exists(json, 'ancillary') ? undefined : GuidIdAndLabelFromJSON(json['ancillary']),
        'ancillaryCategory': !exists(json, 'ancillaryCategory') ? undefined : Int32IdAndLabelFromJSON(json['ancillaryCategory']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'effectiveFrom': !exists(json, 'effectiveFrom') ? undefined : json['effectiveFrom'],
        'effectiveTo': !exists(json, 'effectiveTo') ? undefined : json['effectiveTo'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'additionalInformation': !exists(json, 'additionalInformation') ? undefined : json['additionalInformation'],
    };
}

export function AncillaryDistributionFormDataToJSON(value?: AncillaryDistributionFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'supplier': GuidIdAndLabelToJSON(value.supplier),
        'carrier': GuidIdCodeAndLabelToJSON(value.carrier),
        'ancillary': GuidIdAndLabelToJSON(value.ancillary),
        'ancillaryCategory': Int32IdAndLabelToJSON(value.ancillaryCategory),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'relevance': value.relevance,
        'salesJourneys': value.salesJourneys === undefined ? undefined : (value.salesJourneys === null ? null : (value.salesJourneys as Array<any>).map(CodeAndLabelToJSON)),
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'effectiveFrom': value.effectiveFrom,
        'effectiveTo': value.effectiveTo,
        'allowEdit': value.allowEdit,
        'disabled': value.disabled,
        'additionalInformation': value.additionalInformation,
    };
}


